import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathGreaterThanCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMathGreaterThanCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.6806 7.73857L16.8757 12L8.6806 16.2614L7.98857 14.9306L13.6243 12L7.98857 9.0694L8.6806 7.73857Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathGreaterThanCircle;
